module.exports = __webpack_public_path__ + "img/certificadoM4.0d2c7d0a.png";